<template>
  <v-dialog
    v-model="dialog"
    width="600px"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-toolbar color="#FFB300" dense class="elevation-0" dark>
        <v-card-title> Đơn Mượn: {{ facility.name }} </v-card-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-2">
        <facility-new-form ref="form" @activeButton="isButtonActive" />
      </v-card-text>
      <v-card-actions class="pr-6 pb-6 mt-n8">
        <v-spacer></v-spacer>
        <v-btn
          depressed
          class="px-6"
          color="primary"
          @click="save"
          v-if="buttonActive"
          >Lưu</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import FacilityNewForm from '@/components/basic/form/FacilityAssignForm.vue'

export default {
  components: { FacilityNewForm },
  props: {
    facility: Object,
    state: Boolean
  },
  data: () => ({
    dialog: false,
    buttonActive: false
  }),
  methods: {
    ...mapActions('facilities', [
      'fetchFacilities',
      'createFacility',
      'updateFacility'
    ]),
    isButtonActive(data) {
      this.buttonActive = data
    },
    async save() {
      const data = this.$refs.form.getData()
      await this.updateFacility({
        ...data,
        id: this.facility.id
      })
      this.dialog = false
      this.reset()
    },

    cancel() {
      this.reset()
      this.dialog = false
    },
    reset() {
      this.$refs.form.reset()
    }
  },
  computed: {
    ...mapGetters('app', ['department'])
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
<style scoped></style>
